import * as i18n from "../../i18n.ts";
import * as Html from "../../util/Html.ts";
export {init}

Html.registerWidget('widget/specific/useeventcolor',{init:init})

function init(obj){
  obj.find('input').on('change',function(){
    var key = this.value==='true'?'calendars.singlecoloron':'calendars.singlecoloroff'
    obj.find('.sub4').html(i18n.get(key))
  }).trigger('change')  
}